import { render, staticRenderFns } from "./teacher-signup.vue?vue&type=template&id=c252297c&scoped=true&"
import script from "./teacher-signup.vue?vue&type=script&lang=js&"
export * from "./teacher-signup.vue?vue&type=script&lang=js&"
import style0 from "./teacher-signup.vue?vue&type=style&index=0&id=c252297c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252297c",
  null
  
)

export default component.exports